import { type FC } from 'react';

import { withFlags } from '@confluence/flags/entry-points/withFlags';
import { type FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';

import { useRealtimeAccessRequestsFlags } from './useRealtimeAccessRequestsFlags';

interface RealtimeAccessRequestsProps {
	contentType: string;
	contentId: string;
	flags: FlagsStateContainer;
}

const RealtimeAccessRequestsInternal: FC<RealtimeAccessRequestsProps> = ({
	contentType,
	contentId,
	flags,
}) => {
	useRealtimeAccessRequestsFlags({
		contentId,
		contentType,
		flags,
	});

	return null;
};

export const RealtimeAccessRequests = withFlags(RealtimeAccessRequestsInternal);
